
export const TriviaData = [
    {
        id: 1,
        title: 'Elección presidencial Alfonsín (30/10/1983)',
        data: [{
            id_ques: 1,
            question: "¿Quién fue el primer presidente de la recuperación democrática?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Raúl Alfonsín',
            },
            {
                id_res: 2,
                text: 'Carlos Menem',
            },
            {
                id_res: 3,
                text: 'Fernando de la Rúa',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿De qué partido era el presidente electo?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Unión Cívica Radical',
            },
            {
                id_res: 2,
                text: 'Partido Justicialista',
            },
            {
                id_res: 3,
                text: 'Partido Intransigente',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cuál fue el candidato a presidente peronista que se presentó en 1983?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Italo Argentino Luder',
            },
            {
                id_res: 2,
                text: 'Eduardo Duhalde',
            },
            {
                id_res: 3,
                text: 'Antonio Cafiero',
            },
            ]
        }
    ]
    },
    {
        id: 2,
        title: 'Inicio del juicio a las Juntas Militares',
        data: [{
            id_ques: 1,
            question: "¿Quién fue el fiscal de la Cámara Nacional en lo Criminal que tuvo la responsabilidad de acusar a los integrantes de las Juntas Militares?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Julio Cesar Strassera',
            },
            {
                id_res: 2,
                text: 'Ricardo Gil Lavedra',
            },
            {
                id_res: 3,
                text: 'Jorge Anaya',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Cuál fue el principal tema vinculado con las acusaciones de la Fiscalía?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Corrupción',
            },
            {
                id_res: 2,
                text: 'Violación de los Derechos Humanos',
            },
            {
                id_res: 3,
                text: 'Errores durante la guerra de Malvinas',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cuál de estos altos jefes militares fue condenado a cadena perpetua?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Roberto Eduardo Viola',
            },
            {
                id_res: 2,
                text: 'Jorge Rafael Videla',
            },
            {
                id_res: 3,
                text: 'Leopoldo Fortunato Galtieri',
            },
            ]
        }
    ]
    },
    {
        id: 3,
        title: 'Maradona con la copa',
        data: [{
            id_ques: 1,
            question: " ¿En qué país se jugó el Mundial de Fútbol de 1986?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Australia',
            },
            {
                id_res: 2,
                text: 'Italia',
            },
            {
                id_res: 3,
                text: 'México',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Contra qué país jugó Argentina la final del mundial?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Alemania',
            },
            {
                id_res: 2,
                text: 'Francia',
            },
            {
                id_res: 3,
                text: 'España',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿A qué selección le hizo Maradona el que es considerado el 'mejor gol de la historia de los Mundiales'?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Alemania',
            },
            {
                id_res: 2,
                text: 'Camerún',
            },
            {
                id_res: 3,
                text: 'Inglaterra',
            },
            ]
        }
    ]
    },
    {
        id: 4,
        title: 'Ley de Divorcio Vincular ',
        data: [{
            id_ques: 1,
            question: "¿Cuándo se sancionó la Ley N°23.515 de Divorcio Vincular?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '27 de mayo de 1975',
            },
            {
                id_res: 2,
                text: '8 de junio de 1987',
            },
            {
                id_res: 3,
                text: '3 de octubre de 1991',
            },
            ]
        },
        {
            id_ques: 2,
            question: "Durante la década del ‘80 ¿qué otra ley introdujo reformas en los derechos de familia?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Patria Potestad Compartida, ley N° 23.264',
            },
            {
                id_res: 2,
                text: 'Ley de Acceso a la Interrupción Voluntaria del Embarazo (IVE), ley Nº 27.610',
            },
            {
                id_res: 3,
                text: 'Matrimonio Igualitario',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué permitió la sanción de la Ley N°23.515 de Divorcio Vincular?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Que el matrimonio se puede disolver si existen causas válidas.',
            },
            {
                id_res: 2,
                text: 'Que el matrimonio no se podía disolver por ningún motivo.',
            },
            {
                id_res: 3,
                text: 'Que luego de 5 años el matrimonio se tenía  que disolver obligatoriamente.',
            },
            ]
        }
    ]
    },
    {
        id: 5,
        title: 'Levantamientos militares',
        data: [{
            id_ques: 1,
            question: "¿Quiénes fueron los principales actores de las sublevaciones militares de 1987-1990?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Los militares carapintadas',
            },
            {
                id_res: 2,
                text: 'Los militares azules y colorados',
            },
            {
                id_res: 3,
                text: 'Integrantes del Movimiento Todos por la Patria (MTP) ',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué reclamos hacían los Carapintada?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Mejorar los salarios militares',
            },
            {
                id_res: 2,
                text: 'Modernizar las fuerzas armadas',
            },
            {
                id_res: 3,
                text: 'Suspender los juicios a las juntas militares e indultar a los condenados.',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué consecuencias tuvieron los levantamientos militares?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'El juicio y castigo a los militares sublevados',
            },
            {
                id_res: 2,
                text: 'La sanción de la Ley de Obediencia Debida N° 23.521 en 1987 y los indultos en 1989 y 1990.',
            },
            {
                id_res: 3,
                text: 'Una suba masiva de salarios militares',
            },
            ]
        }]
    },
    {
        id: 6,
        title: 'Saqueos , con focos en diferentes ciudades.',
        data: [{
            id_ques: 1,
            question: "¿Dónde se iniciaron principalmente los saqueos de 1989?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'En Córdoba y Rosario y luego se extendieron a otras ciudades.',
            },
            {
                id_res: 2,
                text: 'En Cutral-Co y Plaza Huincul.',
            },
            {
                id_res: 3,
                text: 'En Ciudad de Buenos Aires.',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Cuál fue la causa principal de los saqueos?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La suba descontrolada del precio de los alimentos por la hiperinflación.',
            },
            {
                id_res: 2,
                text: 'Las limitaciones para comprar dólares.',
            },
            {
                id_res: 3,
                text: 'El bloqueo del retiro de dinero de las cuentas bancarias.',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué salida institucional tuvieron los sucesos de inestabilidad social de 1989?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'El adelantamiento de la asunción del ya electo presidente Menem.',
            },
            {
                id_res: 2,
                text: 'La conformación de un gobierno transitorio.',
            },
            {
                id_res: 3,
                text: 'Un golpe de Estado.',
            },
            ]
        }]
    },{
        id: 7,
        title: 'Primer traspaso presidencial en democracia',
        data: [{
            id_ques: 1,
            question: "¿Durante cuántos años ejerció la presidencia Carlos Menem?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: '10 años',
            },
            {
                id_res: 2,
                text: '6 años',
            },
            {
                id_res: 3,
                text: '8 años',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Cuál fue la principal frase de campaña de Carlos Menem?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: '”Síganme, no los voy a defraudar”',
            },
            {
                id_res: 2,
                text: '”Dicen que soy aburrido…”',
            },
            {
                id_res: 3,
                text: '”Con la democracia se come, se cura y se educa”',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿De qué partido político era Carlos Menem?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Frente Justicialista de Unidad Popular (FREJUPO)',
            },
            {
                id_res: 2,
                text: 'Unión Cívica Radical (UCR)',
            },
            {
                id_res: 3,
                text: 'Izquierda Unida (IU)',
            },
            ]
        }]
    },{
        id: 8,
        title: 'Crimen de María Soledad Morales en Catamarca',
        data: [{
            id_ques: 1,
            question: "¿Por qué causó conmoción popular el crimen de María Soledad Morales el 8 de septiembre de 1990?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Porque fue asesinada por los llamados “hijos del poder catamarqueño" luego de una fiesta',
            },
            {
                id_res: 2,
                text: 'Porque nunca se esclareció',
            },
            {
                id_res: 3,
                text: 'Porque fue asesinada durante un robo',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué consecuencias tuvo el asesinato de María Soledad Morales?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Se realizaron multitudinarias “Marchas del Silencio”',
            },
            {
                id_res: 2,
                text: 'La realización de un juicio al poco tiempo, sin ninguna presión popular',
            },
            {
                id_res: 3,
                text: 'No tuvo ninguna consecuencia, el crimen quedó impune',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Quiénes fueron condenados en juicio por el asesinato de María Soledad Morales?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Dos de los denunciados: Luis Tula y Guillermo Luque',
            },
            {
                id_res: 2,
                text: 'No hubo condenados',
            },
            {
                id_res: 3,
                text: 'Todos los denunciados: Luis Tula, Guillermo Luque, Pablo y Diego Jalil y Miguel Angel Ferreyra (h)',
            },
            ]
        }]
    },
    {
        id: 9,
        title: 'Creación del Mercosur',
        data: [{
            id_ques: 1,
            question: "En 1991 a nivel internacional, se crea:",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'El Fondo Monetario Internacional (FMI)',
            },
            {
                id_res: 2,
                text: 'La Unión de Naciones Suramericanas (UNASUR)',
            },
            {
                id_res: 3,
                text: 'El Mercado Común del Sur (MERCOSUR)',
            },
            ]
        },
        {
            id_ques: 2,
            question: "El MERCOSUR estuvo originalmente conformado por:",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Argentina, Brasil, Chile y Uruguay',
            },
            {
                id_res: 2,
                text: 'Argentina, Chile, Bolivia y Brasil',
            },
            {
                id_res: 3,
                text: 'Argentina, Brasil, Paraguay y Uruguay',
            },
            ]
        },
        {
            id_ques: 3,
            question: "Un antecedente previo al MERCOSUR se encuentra en:",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La declaración de Foz Iguazú  entre Argentina y Brasil',
            },
            {
                id_res: 2,
                text: 'El Tratado de Yacyretá entre Argentina y Paraguay',
            },
            {
                id_res: 3,
                text: 'El tratado de Paz y Amistad entre Argentina y Chile',
            },
            ]
        }
        ]
    },
    {
        id: 10,
        title: 'Inicio del Programa de convertibilidad económica',
        data: [{
            id_ques: 1,
            question: "¿En qué presidencia se aplicó el Programa de Convertibilidad Económica?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Nestor Kirchner',
            },
            {
                id_res: 2,
                text: 'Carlos Saúl Menem',
            },
            {
                id_res: 3,
                text: 'Raúl Alfonsin',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Con qué moneda extranjera se estableció la paridad del peso argentino?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Dólar',
            },
            {
                id_res: 2,
                text: 'Euro',
            },
            {
                id_res: 3,
                text: 'Yuan',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cuánto duró este programa económico?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '1 año',
            },
            {
                id_res: 2,
                text: '11 años',
            },
            {
                id_res: 3,
                text: '5 meses',
            },
            ]
        }]
    },
    {
        id: 11,
        title: 'Pacto de Olivos',
        data: [{
            id_ques: 1,
            question: "¿Cómo se llamó el pacto que permitió la reforma de la Constitución Nacional en 1994?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Pacto de San José de Costa Rica',
            },
            {
                id_res: 2,
                text: 'Pacto de Olivos',
            },
            {
                id_res: 3,
                text: 'Pacto de San Nicolás',
            },
            ]
        },
        {
            id_ques: 2,
            question: "En 1994 se promulgó:",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'La Ley de Punto Final',
            },
            {
                id_res: 2,
                text: 'La Reforma del Código Civil y Comercial',
            },
            {
                id_res: 3,
                text: 'La Reforma de la Constitución Nacional',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Quiénes acordaron la reforma de la Constitución Nacional?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Fernando de la Rúa y Néstor Kirchner',
            },
            {
                id_res: 2,
                text: 'Carlos Menem  y Néstor Kirchner',
            },
            {
                id_res: 3,
                text: 'Carlos Menem y Raúl Alfonsín',
            },
            ]
        }]
    },
    {
        id: 12,
        title: 'Atentado de la AMIA',
        data: [{
            id_ques: 1,
            question: "¿Cuándo ocurrió el atentado en la Asociación Mutual Israelita Argentina  (AMIA)  en Buenos Aires?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '20 de septiembre 1995',
            },
            {
                id_res: 2,
                text: '18 de julio de 1994',
            },
            {
                id_res: 3,
                text: '20 de diciembre de 1994',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿ A qué colectividad se identificó como principal víctima de este atentado?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'La colectividad sirio-libanesa',
            },
            {
                id_res: 2,
                text: 'La colectividad española',
            },
            {
                id_res: 3,
                text: 'La colectividad judía',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Se pudo determinar la autoría del atentado?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'No, hasta el momento permanece impune',
            },
            {
                id_res: 2,
                text: 'Sí, se pudo determinar la autoría mediante una exhaustiva investigación',
            },
            {
                id_res: 3,
                text: 'No se investigó',
            },
            ]
        }]
    },{
        id: 13,
        title: 'Sanción de la Reforma Constitucional',
        data: [{
            id_ques: 1,
            question: "La Asamblea Constitucional sesionó en la ciudad de:",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Buenos Aires',
            },
            {
                id_res: 2,
                text: 'Paraná y Santa Fe',
            },
            {
                id_res: 3,
                text: 'La Falda',
            },
            ]
        },
        {
            id_ques: 2,
            question: "La reforma de la Constitución Nacional estableció:",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La reelección presidencial por un segundo período',
            },
            {
                id_res: 2,
                text: 'La reelección presidencial por tres períodos',
            },
            {
                id_res: 3,
                text: 'La reelección presidencial indefinida',
            },
            ]
        },
        {
            id_ques: 3,
            question: "La reforma de la Constitución Nacional otorgó jerarquía constitucional a:",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Los tratados comerciales celebrados con terceros países',
            },
            {
                id_res: 2,
                text: 'Los tratados internacionales de Derechos Humanos',
            },
            {
                id_res: 3,
                text: 'Los tratados de libre comercio',
            },
            ]
        }]
    },
    {
        id: 14,
        title: 'Eliminación del Servicio Militar Obligatorio',
        data: [{
            id_ques: 1,
            question: "Como consecuencia del crimen de Omar Carrasco, en la Argentina:",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Se eliminó el Servicio Militar Obligatorio',
            },
            {
                id_res: 2,
                text: 'Se eliminó el fuero militar',
            },
            {
                id_res: 3,
                text: 'Se acentuó el control civil sobre las Fuerzas Armadas',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Quién gobernaba la Argentina en ese momento?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Raúl Alfonsín',
            },
            {
                id_res: 2,
                text: 'Carlos Menem',
            },
            {
                id_res: 3,
                text: 'Eduardo Duhalde',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Quién era Omar Carrasco?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Un ciudadano que cumplía el servicio militar obligatorio',
            },
            {
                id_res: 2,
                text: 'Un empresario',
            },
            {
                id_res: 3,
                text: 'Un cadete de la escuela militar',
            },
            ]
        }]
    },
    {
        id: 15,
        title: 'Surgimiento de la agrupación HIJOS',
        data: [{
            id_ques: 1,
            question: "¿H.I.J.O.S es una organización de qué tipo?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Sindical',
            },
            {
                id_res: 2,
                text: 'Artística',
            },
            {
                id_res: 3,
                text: 'De Derechos Humanos',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué significa la sigla H.I.J.O.S?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Hijos por la Igualdad y la Justicia contra la Opresión y el Sometimiento',
            },
            {
                id_res: 2,
                text: 'Hijos e hijas por la Identidad y la Justicia contra el Olvido y el Silencio',
            },
            {
                id_res: 3,
                text: 'Hijos e hijas por la Ideología y la Justicia contra el Olvido y la Soledad',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿En qué año se creó la organización?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '1983',
            },
            {
                id_res: 2,
                text: '1995',
            },
            {
                id_res: 3,
                text: '2015',
            },
            ]
        }]
    },
    {
        id: 16,
        title: 'Surgimiento del movimiento piquetero',
        data: [{
            id_ques: 1,
            question: "A finales de la década del ‘90, y como consecuencia de las políticas económicas aplicadas, surge en Argentina:",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'El movimiento de pequeños y medianos empresarios',
            },
            {
                id_res: 2,
                text: 'El movimiento piquetero',
            },
            {
                id_res: 3,
                text: 'El movimiento de chacareros y pequeños productores agropecuarios',
            },
            ]
        },
        {
            id_ques: 2,
            question: "Las primeras experiencias de este nuevo movimiento surgen en:",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Cutral Có y Plaza Huincul',
            },
            {
                id_res: 2,
                text: 'Rosario y Buenos Aires',
            },
            {
                id_res: 3,
                text: 'Rosario y Tartagal',
            },
            ]
        },
        {
            id_ques: 3,
            question: "Las principales acciones del movimiento fueron:",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Corte de rutas y puebladas',
            },
            {
                id_res: 2,
                text: 'Tomas de tierras y de establecimientos productivos',
            },
            {
                id_res: 3,
                text: 'Tomas de edificios públicos  ',
            },
            ]
        }]
    },
    {
        id: 17,
        title: 'Comienzo de la protesta docente denominada Carpa Blanca',
        data: [{
            id_ques: 1,
            question: "Entre 1997 y 1999 tuvo lugar en la Argentina, una de las protestas sociales-gremiales más extensas de la historia, nos referimos a:",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La Carpa Blanca liderada por docentes argentinos',
            },
            {
                id_res: 2,
                text: 'La toma de General Mosconi lideradas por trabajadores de YPF',
            },
            {
                id_res: 3,
                text: 'La protesta en el puerto de Rosario de trabajadores portuarios y afines',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué organización sindical participó plenamente en la protesta?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'La Confederación Nacional del Trabajo (CGT)',
            },
            {
                id_res: 2,
                text: 'La Confederación de Trabajadores de la Educación (CTERA)',
            },
            {
                id_res: 3,
                text: 'El Sindicato Argentino de Docentes Particulares (SADOP)',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué se reclamaba?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Aumento de los fondos para la educación pública',
            },
            {
                id_res: 2,
                text: 'El no pago a la deuda externa',
            },
            {
                id_res: 3,
                text: 'La oposición a la reforma curricular de la educación pública',
            },
            ]
        }]
    },
    {
        id: 18,
        title: 'Crisis de 2001',
        data: [{
            id_ques: 1,
            question: "¿Qué presidente renunció en 2001?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Carlos Saul Menem',
            },
            {
                id_res: 2,
                text: 'Raúl Alfonsin',
            },
            {
                id_res: 3,
                text: 'Fernando de la Rúa',
            },
            ]
        },
        {
            id_ques: 2,
            question: "En ese período",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Se podía sacar dinero en efectivo con normalidad',
            },
            {
                id_res: 2,
                text: 'Se restringió el retiro de dinero en efectivo en las entidades bancarias',
            },
            {
                id_res: 3,
                text: 'Se produjo la dolarización',
            },
            ]
        },
        {
            id_ques: 3,
            question: "El 2 de enero de 2002, luego de que se sucedieran Fernando de la Rúa, Ramón Puerta, Adolfo Rodríguez Saa y Eduardo Camaño, ¿quién asumió como presidente?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Eduardo Duhalde',
            },
            {
                id_res: 2,
                text: 'Eduardo Menem',
            },
            {
                id_res: 3,
                text: 'Nestor Kirchner',
            },
            ]
        }]
    },
    {
        id: 19,
        title: 'Fin de la Convertibilidad Económica y pesificación de los depósitos bancarios en moneda extranjera',
        data: [{
            id_ques: 1,
            question: "La derogación de algunos artículos de la Ley de Convertibilidad puso fin a:",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'El patrón oro',
            },
            {
                id_res: 2,
                text: 'La paridad cambiaria con el dólar 1 a 1',
            },
            {
                id_res: 3,
                text: 'El proceso de privatización de empresas públicas',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Quién gobernaba en la Argentina cuando se terminó la paridad peso dólar 1 a 1?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Ramón Puerta',
            },
            {
                id_res: 2,
                text: 'Adolfo Rodriguez Saa',
            },
            {
                id_res: 3,
                text: 'Eduardo Duhalde',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué pasó con los depósitos bancarios realizados por los ahorristas  en moneda extranjera?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Se pesificaron',
            },
            {
                id_res: 2,
                text: 'Se respetaron',
            },
            {
                id_res: 3,
                text: 'Se congelaron',
            },
            ]
        }]
    },
    {
        id: 20,
        title: 'Derogación de las leyes de Obediencia Debida y Punto Final',
        data: [{
            id_ques: 1,
            question: "¿Qué leyes se anularon el 21 de agosto de 2003?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Ley de Convertibilidad',
            },
            {
                id_res: 2,
                text: 'Ley de Obediencia Debida y Punto Final',
            },
            {
                id_res: 3,
                text: 'Ley de Alquileres y de Reforma del Estado',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Durante qué gobierno se produjo dicha anulación?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Carlos Menem',
            },
            {
                id_res: 2,
                text: 'Eduardo Duhalde',
            },
            {
                id_res: 3,
                text: 'Néstor Kirchner',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué permitió dicha anulación?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La reanudación de juicios por crímenes de lesa humanidad cometidos durante la última dictadura',
            },
            {
                id_res: 2,
                text: 'La investigación sobre el atentado a la AMIA',
            },
            {
                id_res: 3,
                text: 'La reanudación de las negociaciones por los límites con Chile',
            },
            ]
        }]
    },
    {
        id: 21,
        title: 'Incendio en la discoteca Cromañón',
        data: [{
            id_ques: 1,
            question: "¿Cuál era el nombre del empresario dueño de la discoteca Cromañón?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Adrián Conci',
            },
            {
                id_res: 2,
                text: 'Omar Chabán',
            },
            {
                id_res: 3,
                text: 'Ignacio Cubillas',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué grupo de rock tocó el día del incendio de la discoteca?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Callejeros',
            },
            {
                id_res: 2,
                text: 'La 25',
            },
            {
                id_res: 3,
                text: 'Árbol',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué consecuencias políticas tuvo el incendio por una bengala de la discoteca Cromañón?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La destitución por juicio político del Jefe de Gobierno porteño Aníbal Ibarra',
            },
            {
                id_res: 2,
                text: 'La destitución por juicio político del gobernador Carlos Ruckauf',
            },
            {
                id_res: 3,
                text: 'No tuvo consecuencias políticas',
            },
            ]
        }]
    },
    {
        id: 22,
        title: '4 ta. Cumbre de las Américas',
        data: [{
            id_ques: 1,
            question: "¿Quiénes fueron los conductores del rechazo al ALCA en la 4ta Cumbre de las Américas?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'George Bush, Vicente Fox y Paul Martin',
            },
            {
                id_res: 2,
                text: 'Néstor Kirchner, Lula da Silva y Hugo Chávez',
            },
            {
                id_res: 3,
                text: 'Martín Torrijos, Patrick Manning y Samuel Lewis',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿En qué ciudad argentina se hizo la 4ta Cumbre de las Américas?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Mar del Plata',
            },
            {
                id_res: 2,
                text: 'Rosario',
            },
            {
                id_res: 3,
                text: 'Ciudad de Mendoza',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cuál fue la consigna principal de la Contracumbre o III Cumbre de los Pueblos?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'No al ALCA',
            },
            {
                id_res: 2,
                text: 'No al ALBA',
            },
            {
                id_res: 3,
                text: 'No al Mercosur',
            },
            ]
        }]
    },
    {
        id: 23,
        title: 'Desaparición de Jorge Julio López',
        data: [{
            id_ques: 1,
            question: "¿Quién fue el primer desaparecido en Democracia?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Santiago Maldonado',
            },
            {
                id_res: 2,
                text: 'Jorge Julio López',
            },
            {
                id_res: 3,
                text: 'Rodolfo Walsh ',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿En qué año se produjo la primera desaparición conocida en Democracia?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: '2001',
            },
            {
                id_res: 2,
                text: '1985',
            },
            {
                id_res: 3,
                text: '2006',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿En qué ciudad argentina residía/vivía/se lo vio por última vez?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La Plata',
            },
            {
                id_res: 2,
                text: 'Córdoba',
            },
            {
                id_res: 3,
                text: 'Rosario',
            },
            ]
        }]
    },
    {
        id: 24,
        title: 'Paro y movilización de las entidades agropecuarias',
        data: [{
            id_ques: 1,
            question: "¿En qué año tuvo lugar el “conflicto del campo”, denominado así por los medios masivos de comunicación?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '2007',
            },
            {
                id_res: 2,
                text: '2008',
            },
            {
                id_res: 3,
                text: '2009',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Quién fue el Ministro de Economía que firmó la Resolución 125/08?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Hernán Lorenzino',
            },
            {
                id_res: 2,
                text: 'Amado Boudou',
            },
            {
                id_res: 3,
                text: 'Martín Lousteau',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cuánto tiempo duró este conflicto? ",
            correct: 1,
            responses:[{
                id_res: 1,
                text: '129 días',
            },
            {
                id_res: 2,
                text: '4 días',
            },
            {
                id_res: 3,
                text: '250 días',
            },
            ]
        }]
    },
    {
        id: 25,
        title: 'Re-estatización de los fondos de jubilaciones y pensiones.',
        data: [{
            id_ques: 1,
            question: "¿Durante qué presidencia se crearon las Administradoras de Fondos de Jubilaciones y Pensiones (AFJP) que permitían la capitalización privada e individual de los aportes jubilatorios?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Raúl Alfonsín',
            },
            {
                id_res: 2,
                text: 'Carlos Menem',
            },
            {
                id_res: 3,
                text: 'Néstor Kirchner',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Quién ejercía la presidencia durante el proceso de estatización de los fondos de jubilaciones y pensiones?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Cristina Fernández de Kirchner',
            },
            {
                id_res: 2,
                text: 'Mauricio Macri',
            },
            {
                id_res: 3,
                text: 'Alberto Fernández',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cómo se denomina el sistema previsional en Argentina desde su estatización en el año 2008?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Fondo Nacional de Salud',
            },
            {
                id_res: 2,
                text: 'Sistema de Seguro Social',
            },
            {
                id_res: 3,
                text: 'Sistema Integrado Previsional Argentino',
            },
            ]
        }]
    },
    {
        id: 26,
        title: 'Aprobación de la Ley de servicios de comunicación audiovisual.',
        data: [{
            id_ques: 1,
            question: "¿Cuál es la ley que protege y controla que no exista monopolio de medios?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Ley de Servicios de Comunicación Audiovisual',
            },
            {
                id_res: 2,
                text: 'Ley de Libertad de Expresión',
            },
            {
                id_res: 3,
                text: 'Ley de Servicios de Radiodifusión',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿De qué año era la ley anterior que regulaba los medios de comunicación?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '1987',
            },
            {
                id_res: 2,
                text: '1980',
            },
            {
                id_res: 3,
                text: '2001',
            },
            ]
        },
        {
            id_ques: 3,
            question: "La llamada Ley de Medios declara la actividad de comunicación audiovisual como:",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Un simple servicio público',
            },
            {
                id_res: 2,
                text: 'Una actividad privada exenta del control del Estado',
            },
            {
                id_res: 3,
                text: 'Una actividad de interés público regulada por el Estado',
            },
            ]
        }]
    },
    {
        id: 27,
        title: 'Decreto de aprobación de la Asignación Universal por Hijo (AUH).',
        data: [{
            id_ques: 1,
            question: "¿Cómo se llama la prestación monetaria mensual a la que tienen derecho los menores de 18 años y personas con discapacidad cuando el grupo familiar no tiene empleo formal?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Asignación Universal por Hijo (AUH)',
            },
            {
                id_res: 2,
                text: 'Programa Potenciar Inclusión Joven',
            },
            {
                id_res: 3,
                text: 'Plan Nacional de Protección Social',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué organismo gubernamental paga esta asignación?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Ministerio de Desarrollo Social/Programa Nacional de Protección Social',
            },
            {
                id_res: 2,
                text: 'ANSES (Administración Nacional de Seguridad Social)',
            },
            {
                id_res: 3,
                text: 'Ministerio de Salud de la Nación',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cómo se llamó el refuerzo para alimentos que complementó la Asignación Universal por Hijo (AUH) ?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Tarjeta Alimentar',
            },
            {
                id_res: 2,
                text: 'Tarjeta Sube',
            },
            {
                id_res: 3,
                text: 'Tarjeta Ciudadana',
            },
            ]
        }]
    },
    {
        id: 28,
        title: 'Festejos del Bicentenario de la Revolución de Mayo.',
        data: [{
            id_ques: 1,
            question: "¿Qué ciudad fue el epicentro de los festejos del Bicentenario de la Revolución de Mayo?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Ciudad de Buenos Aires',
            },
            {
                id_res: 2,
                text: ' Ciudad de Santiago del Estero',
            },
            {
                id_res: 3,
                text: 'Ciudad de Córdoba',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué grupo músical/teatral tuvo a su cargo el Desfile del Bicentenario que se hizo el 25 de mayo de 2010 sobre la Avenida 9 de Julio?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'El Choque Urbano',
            },
            {
                id_res: 2,
                text: 'Mayumana',
            },
            {
                id_res: 3,
                text: 'Fuerza Bruta',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué Centro Cultural se inauguró en el antiguo edificio del Palacio de Correos y Telecomunicaciones durante los Festejos del Bicentenario de la Revolución de Mayo?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Centro Cultural Recoleta',
            },
            {
                id_res: 2,
                text: 'Centro Cultura Kirchner',
            },
            {
                id_res: 3,
                text: 'Espacio Cultural Usina del Arte',
            },
            ]
        }]
    },
    {
        id: 29,
        title: 'Ley de Matrimonio Igualitario',
        data: [{
            id_ques: 1,
            question: " ¿En qué año se sancionó la primera ley que posibilitó el matrimonio entre personas del mismo género?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: '2007',
            },
            {
                id_res: 2,
                text: '2009',
            },
            {
                id_res: 3,
                text: '2010',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Quién ejercía la presidencia cuando se sancionó la Ley de Matrimonio Igualitario?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Cristina Fernández de Kirchner',
            },
            {
                id_res: 2,
                text: 'Carlos Saúl Menem',
            },
            {
                id_res: 3,
                text: 'Mauricio Macri',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cuál es el primer país latinoamericano que aprobó una Ley de Matrimonio Igualitario?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Argentina',
            },
            {
                id_res: 2,
                text: 'Brasil',
            },
            {
                id_res: 3,
                text: 'Uruguay',
            },
            ]
        }]
    },
    {
        id: 30,
        title: 'Protestas de la clase media urbana entre mayo de 2012 y agosto 2013, el “8N” (8/11/2012)',
        data: [{
            id_ques: 1,
            question: "¿Cómo se llamó a las protestas de clase media de 2012 y 2013?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Cacerolazos',
            },
            {
                id_res: 2,
                text: 'Furia popular',
            },
            {
                id_res: 3,
                text: 'Revuelta porteña',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué motivó las protestas?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Pedido de Reforma de la Corte Suprema de Justicia',
            },
            {
                id_res: 2,
                text: 'Rechazo a la inflación, corrupción, cepo al dólar, pedido de justicia independiente',
            },
            {
                id_res: 3,
                text: 'Rechazo a la presencia de la Reina de Inglaterra',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Por qué medios se convocó a las protestas del #8N?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Por redes sociales digitales (Facebook, SMS y emails)',
            },
            {
                id_res: 2,
                text: 'Cartas y solicitudes en los diarios',
            },
            {
                id_res: 3,
                text: 'Por asambleas barriales y folletos',
            },
            ]
        }]
    },
    {
        id: 31,
        title: 'Lanzamiento del primer satélite de comunicaciones…',
        data: [{
            id_ques: 1,
            question: " ¿Qué es el ArSat-1?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Una enfermedad similar al Covid-19',
            },
            {
                id_res: 2,
                text: 'Un software que permite escanear personas a través de biometría en las terminales de ómnibus de Argentina',
            },
            {
                id_res: 3,
                text: 'Un satélite geoespacial construido en Argentina',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Por qué es importante el ArSat-1 para Argentina?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Porque la convirtió en una de las 8 naciones del mundo con capacidad de construir satélites espaciales',
            },
            {
                id_res: 2,
                text: 'Porque le permitió desarrollar software de identificación vehicular de gran porte',
            },
            {
                id_res: 3,
                text: 'Porque fue un hito en la carrera aeroespacial',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Para qué sirve el ArSat-1?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Ofrece servicios de telecomunicaciones, internet, telefonía, televisión digital y transmisión de datos para gran parte de América del Sur',
            },
            {
                id_res: 2,
                text: 'Ofrece servicios de logística, transporte, carga y descarga a la flota de camiones que viajan por los países del Mercosur',
            },
            {
                id_res: 3,
                text: 'Colecta y clasifica especímenes florales con utilidad fitosanitaria en los cultivos frutales de la Mesopotamia en Argentina',
            },
            ]
        }]
    },
    {
        id: 32,
        title: 'Aparición sin vida del cuerpo de Franco Casco.',
        data: [{
            id_ques: 1,
            question: "¿Quién fue Franco Casco?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Un joven víctima de violencia institucional en una comisaría',
            },
            {
                id_res: 2,
                text: 'Un militante social desaparecido durante una manifestación estudiantil en Buenos Aires',
            },
            {
                id_res: 3,
                text: 'Un artista reconocido que desapareció en un evento cultural en la ciudad de Mendoza',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿En qué ciudad fue asesinado?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Rosario',
            },
            {
                id_res: 2,
                text: 'Bariloche',
            },
            {
                id_res: 3,
                text: 'Ciudad Autónoma de Buenos Aires',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué decidió la Justicia respecto de los policías imputados?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Están cumpliendo cadena perpetua',
            },
            {
                id_res: 2,
                text: 'Fueron absueltos',
            },
            {
                id_res: 3,
                text: 'Nunca llegaron a juicio',
            },
            ]
        }]
    },
    {
        id: 33,
        title: 'Marcha “Ni Una Menos” Paro Internacional de Mujeres',
        data: [{
            id_ques: 1,
            question: "¿Cuál fue la principal consigna de la Marcha “Ni Una Menos” realizada en Argentina el 3 de junio de 2015?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Marchar por el salario social complementario',
            },
            {
                id_res: 2,
                text: 'Recortar los planes sociales anunciados por el Gobierno',
            },
            {
                id_res: 3,
                text: 'Marchar contra los femicidios y la violencia de género',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Con qué movimiento social se identifica la consigna “Ni Una Menos”?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Con los piqueteros',
            },
            {
                id_res: 2,
                text: 'Con los feminismos',
            },
            {
                id_res: 3,
                text: 'Con los movimientos religiosos',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿La movilización convocada con la consigna “Ni Una Menos” fue importante fuera de Argentina?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'No, solo se circunscribió al Área Metropolitana de Buenos Aires',
            },
            {
                id_res: 2,
                text: 'Sí, posteriormente se replicaron movilizaciones similares en toda América Latina, Europa y Asia',
            },
            {
                id_res: 3,
                text: 'Sí, porque se replicó en la Bienal del Mercosur en la ciudad de Porto Alegre (Brasil)',
            },
            ]
        }]
    },
    {
        id: 34,
        title: 'Entra en vigencia el nuevo Código Civil y Comercial',
        data: [{
            id_ques: 1,
            question: "¿Cuándo entró en vigencia el nuevo Código Civil y Comercial de la Nación?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: '2015',
            },
            {
                id_res: 2,
                text: '2018',
            },
            {
                id_res: 3,
                text: '2005',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Qué modificación relacionada con los nombre de las personas se introduce en el nuevo Código Civil y Comercial?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Sólo se puede llevar el apellido materno',
            },
            {
                id_res: 2,
                text: 'Se puede colocar el apellido materno y paterno',
            },
            {
                id_res: 3,
                text: 'Las personas eligen apellido definitivo después de los 18 años',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Quién redactó el Código Civil y Comercial vigente?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Una comisión de juristas',
            },
            {
                id_res: 2,
                text: 'Dalmacio Vélez Sársfield',
            },
            {
                id_res: 3,
                text: 'Una comisión de traductores',
            },
            ]
        }]
    },
    {
        id: 35,
        title: 'Eliminación de los derechos de exportación.',
        data: [{
            id_ques: 1,
            question: "¿Qué productos son los que generan mayores ingresos por los derechos de exportación?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Autos',
            },
            {
                id_res: 2,
                text: 'Trigo, maíz y soja',
            },
            {
                id_res: 3,
                text: 'Vino',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Por qué se eliminaron y redujeron las retenciones del trigo, maíz y soja, entre otros productos, en 2015?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Porque Argentina estaba bien económicamente',
            },
            {
                id_res: 2,
                text: 'Porque había sido una promesa de campaña del presidente Macri al sector del agro',
            },
            {
                id_res: 3,
                text: 'Porque hubo sequía',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿El gobierno de Macri fue la única administración desde 1983 a 2023 que bajó las retenciones a la soja?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Si, todos lo prometieron pero solo él lo implementó',
            },
            {
                id_res: 2,
                text: 'No, todos los gobiernos democráticos bajaron al menos 1% los derechos de exportación a la soja',
            },
            {
                id_res: 3,
                text: 'No, los gobiernos de Raúl Alfonsín y Carlos Menem también las bajaron considerablemente',
            },
            ]
        }]
    },

    {
        id: 36,
        title: 'Solicitud de préstamo al FMI por 55 mil millones de dólares',
        data: [{
            id_ques: 1,
            question: "¿Quién le prestó al gobierno nacional presidido por Mauricio Macri 55 mil millones de dólares en el 2018?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Banco Mundial',
            },
            {
                id_res: 2,
                text: 'Naciones Unidas',
            },
            {
                id_res: 3,
                text: 'Fondo Monetario Internacional',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Para qué se utilizó principalmente el préstamo recibido?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'Pagar vencimientos de deuda en moneda extranjera',
            },
            {
                id_res: 2,
                text: 'Comprar oro para atesorar en el Banco Central',
            },
            {
                id_res: 3,
                text: 'Para obra pública y planes sociales',
            },
            ]
        },
        {
            id_ques: 3,
            question: "El préstamo otorgado por el organismo internacional fue...",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'El más pequeño prestado a un país en su historia',
            },
            {
                id_res: 2,
                text: 'El más grande prestado a un país en su historia',
            },
            {
                id_res: 3,
                text: 'El monto habitual prestado a un país en su historia',
            },
            ]
        }]
    },
    {
        id: 37,
        title: 'Se decreta el Aislamiento Social Preventivo y Obligatorio',
        data: [{
            id_ques: 1,
            question: "¿Qué es el ASPO?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Una inteligencia artificial',
            },
            {
                id_res: 2,
                text: 'Una medida de aislamiento social obligatorio durante la pandemia',
            },
            {
                id_res: 3,
                text: 'Un medicamento',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿En qué año se decretó el ASPO (Aislamiento Social Preventivo y Obligatorio)?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: '2001',
            },
            {
                id_res: 2,
                text: '2020',
            },
            {
                id_res: 3,
                text: '1983',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Qué intentaba evitar el ASPO?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'La compra de dólares',
            },
            {
                id_res: 2,
                text: 'El contagio masivo de coronavirus',
            },
            {
                id_res: 3,
                text: 'Una guerra nuclear',
            },
            ]
        }]
    },
    {
        id: 38,
        title: 'Aprobación de la Ley de Interrupción Voluntaria del Embarazo',
        data: [{
            id_ques: 1,
            question: "¿Qué es la IVE?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Una moneda digital',
            },
            {
                id_res: 2,
                text: 'Un corte de pelo',
            },
            {
                id_res: 3,
                text: 'Un procedimiento médico realizado para poner fin a un embarazo no deseado',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿Desde qué año se puso en práctica legal la IVE (Interrupción Voluntaria del Embarazo)?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: '2011',
            },
            {
                id_res: 2,
                text: '2018',
            },
            {
                id_res: 3,
                text: '2021',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Quién peticionó como un derecho la IVE?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'La iglesia católica',
            },
            {
                id_res: 2,
                text: 'Los feminismos',
            },
            {
                id_res: 3,
                text: 'El movimiento de cabezas rapadas',
            },
            ]
        }]
    },
    {
        id: 39,
        title: 'La Selección Argentina de fútbol masculino.',
        data: [{
            id_ques: 1,
            question: "¿Cuántas personas salieron a festejar la victoria argentina en el Mundial Qatar 2022?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Un millón de personas',
            },
            {
                id_res: 2,
                text: '500 mil personas',
            },
            {
                id_res: 3,
                text: 'Cinco millones de personas',
            },
            ]
        },
        {
            id_ques: 2,
            question: "Durante el Mundial de Fútbol masculino Qatar se produjeron acusaciones sobre violaciones a los derechos humanos. ¿Qué se denunció?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La persecución hacia el colectivo LGBTIQ+ y el uso de un sistema laboral esclavizante durante la construcción de los estadios',
            },
            {
                id_res: 2,
                text: 'Casos de corrupción política',
            },
            {
                id_res: 3,
                text: 'Baja calidad de la infraestructura para recibir a personas con movilidad reducida',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Por qué el Mundial se jugó a fin de año en lugar de junio-julio como suele ser?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Porque las ligas europeas sólo permitieron ceder a los jugadores seleccionados durante ese período',
            },
            {
                id_res: 2,
                text: 'El clima de Qatar hizo peligroso jugar a mitad de año por las elevadas temperaturas',
            },
            {
                id_res: 3,
                text: 'Fue una decisión comercial de FIFA',
            },
            ]
        }]
    },
    {
        id: 40,
        title: 'Asunción de Javier Milei',
        data: [{
            id_ques: 1,
            question: "¿Quién asumió como presidente el 10 de diciembre de 2023?",
            correct: 2,
            responses:[{
                id_res: 1,
                text: 'Patricia Bullrich',
            },
            {
                id_res: 2,
                text: 'Javier Milei',
            },
            {
                id_res: 3,
                text: 'Cristina Kirchner',
            },
            ]
        },
        {
            id_ques: 2,
            question: "¿A qué tradición ideológica dice adherir Javier Milei?",
            correct: 3,
            responses:[{
                id_res: 1,
                text: 'Socialismo',
            },
            {
                id_res: 2,
                text: 'Peronismo',
            },
            {
                id_res: 3,
                text: 'Liberal-libertario',
            },
            ]
        },
        {
            id_ques: 3,
            question: "¿Cómo se denomina el partido de Javier Milei?",
            correct: 1,
            responses:[{
                id_res: 1,
                text: 'La Libertad Avanza',
            },
            {
                id_res: 2,
                text: 'Juntos por el Cambio',
            },
            {
                id_res: 3,
                text: 'Frente de Izquierda',
            },
            ]
        }]
    }
]